module.exports = __webpack_public_path__ + "static/media/web-survey-logo.41897475.png";